import Layout from "@/layout/index.vue";

export default [
  // 养老
  {
    path: "/yl",
    name: "yl",
    component: Layout,
    redirect: "/yl/clue-issued",
    meta: {
      title: "养老管理",
    },
    children: [
      {
        path: "/yl/clue-issued",
        name: "ylClueIssued",
        component: () => import("@/views/page/yanglao/pages/clue-issued/index.vue"),
        meta: {
          title: "泰康线索用户加急/投诉反馈",
          newPage: true,
        },
      },
      {
        path: "/yl/clue-monitor",
        name: "yLClueMonitor",
        component: () => import("@/views/page/yanglao/pages/clue-monitor/index.vue"),
        meta: {
          title: "小蓝表",
          newPage: true,
        },
      },
      {
        path: "/yl/clue-enter",
        name: "ylClueEnter",
        component: () => import("@/views/page/yanglao/pages/clue-enter/index.vue"),
        meta: {
          title: "线索录入",
          newPage: true,
          noCache: true
        },
      },
      {
        path: "/yl/live-clue-list",
        name: "ylLiveClueList",
        component: () =>
          import("@/views/page/yanglao/pages/live-clue-list/index.vue"),
        meta: {
          title: "线索管理",
          newPage: true,
        },
      },
      {
        path: "/yl/supply-plan-list",
        name: "ylSupplyPlanList",
        component: () =>
          import("@/views/page/yanglao/pages/supply-plan-list/index.vue"),
        meta: {
          title: "供数计划配置",
          newPage: true,
        },
      },
      {
        path: "/yl/tk-order-report-list",
        name: "ylTkOrderReportList",
        component: () =>
          import("@/views/page/yanglao/pages/tk-order-report-list/index.vue"),
        meta: {
          title: "泰康出单概率报表",
          newPage: true,
        },
      },
      {
        path: "/yl/live-feedback",
        name: "ylLiveFeedback",
        component: () =>
          import("@/views/page/yanglao/pages/live-feedback/index.vue"),
        meta: {
          title: "直播反馈",
          newPage: true,
        },
      },
      {
        path: "/yl/material-list",
        name: "ylMaterialList",
        component: () =>
          import("@/views/page/yanglao/pages/material-list/index.vue"),
        meta: {
          title: "素材管理",
          newPage: true,
        },
      },
      {
        path: "/yl/budget-list",
        name: "ylBudgetList",
        component: () =>
          import("@/views/page/yanglao/pages/budget-list/index.vue"),
        meta: {
          title: "预算管理",
          newPage: true,
        },
      },
    ],
  },
]